import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openDepositDialog: false,
  snackbar: {
    openSnackbar: false,
    message: '',
  },
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setOpenDepositDialog(state, action) {
      state.openDepositDialog = action.payload;
    },
    setSnackbar(state, action) {
      const { openSnackbar, message } = action.payload;
      state.snackbar.openSnackbar = openSnackbar;
      state.snackbar.message = message;
    },
  },
});

export default commonSlice;
export const { setSnackbar, setOpenDepositDialog } = commonSlice.actions;
